import React, { Component } from 'react'
import Card from '../components/Card'
import Image from '../components/Image'
import Paragraph from '../components/Paragraph'
import Row from '../components/Row'

export default class UseTip extends Component {
  render() {
    const { image, str, children } = this.props

    return (
      <Card>
        <Card.Pad>
          <Row alignCenter>
            <Row.Cell style={{ marginRight: '2rem' }}>
              <Image src={image} />
            </Row.Cell>
            <Row.Cell flex="3">
              {!!str && <Paragraph str={str} />}
              {!str && <Paragraph>{children}</Paragraph>}
            </Row.Cell>
          </Row>
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UseTip.js